<script setup lang="ts">
import {ConversationMessage} from "@/conversation/interfaces";
import {computed} from "vue";
import MessageSourceBadge from "@/communication/components/MessageSourceBadge.vue";
import {TRIGGER_TYPE_LABELS, triggerTypeOf} from "@/conversation/services/triggerType";
import {Badge} from "@/core/components/ui/badge";

const props = defineProps<{
    message: ConversationMessage;
}>();

const triggerLabel = computed(() => TRIGGER_TYPE_LABELS[triggerTypeOf(props.message)]);
</script>

<template>
  <div class="flex flex-col gap-1 items-start">
    <Badge variant="outline">
      {{ triggerLabel }}
    </Badge>
    <MessageSourceBadge v-if="message.sourceable" :type="message.sourceable?.type ?? null" :name="message.sourceable?.name" />
  </div>
</template>

<style scoped>

</style>
